import styled from 'styled-components'
import { Alert } from '@amzn/storm-ui'
export const AlertContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing.large};
  display: flex;
  justify-content: center;
`
export const StyledAlert = styled(Alert)`
  width: 49%;
`
